// Native
import { useState } from "react"
import { useNavigate } from "react-router"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, useDisclosure, useToast } from "@chakra-ui/react";
import { Dialog, Icon } from "components"

// Config
import { API } from "config"

// Hooks
import { useEmployees } from "hooks"

// Screens
import { Authenticate } from "screens"

export default function Trash({ data, ...props }){

    const navigate = useNavigate()
    const toast = useToast()
    const employees = useEmployees()
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()

    const handleTrash = async () => {
        setLoading(true)

        try{
            await API.delete(`/employees/${data.id}`)
            toast({ title: 'O funcionário foi removido.' })
            employees.refetch()
            navigate('/employees')
        }catch(err){
            toast({ title: 'Não foi possível remover o funcionário.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Dialog title={`Certeza que deseja excluir ${data?.name}?`} loading={loading} {...props}>
        <AlertDialogBody>
            Ao excluir um funcionário, ele não perderá acesso ao sistema e o histórico de ações dele pode ser perdido.
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button colorScheme="orange" children="Remover funcionário" leftIcon={<Icon name="trash" />} onClick={auth.onOpen} isLoading={loading} />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    <Authenticate {...auth} onSuccess={handleTrash} />
    </>
    )
}